import { authClient, API } from '../index'

export const countTexts = () => {
  return authClient().get(`${API}/text/count`)
}

export const getTexts = () => {
  return authClient().get(`${API}/text`)
}

export const getTextById = (id) => {
  return authClient().get(`${API}/text/${id}`)
}

export const updateText = (id, text) => {
  return authClient().put(`${API}/text/${id}`, text)
}

export const postText = (text) => {
  return authClient().post(`${API}/text`, text)
}

export const deleteText = (id) => {
  return authClient().delete(`${API}/text/${id}`)
}